var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full rounded-xl overflow-auto p-7",class:_vm.darkMode ? 'dark' : 'light',staticStyle:{"box-shadow":"0 0 10px 0 rgba(0, 0, 0, 0.09)"}},[_c('National')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }